export const BASE_URL_GRAPH = "https://graph.microsoft.com/v1.0";
export const BASE_URL = "https://provisioning.heedify.io";